<template> </template>


<script>
  import { createPage } from '@didi/es-mpx-creator'

  createPage({
    data: {},
    methods: {}
  })
</script>

<style lang='stylus' scoped></style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>